// @module BTM.AutomaticStoreAssignment.AutomaticStoreAssignment
define('BTM.AutomaticStoreAssignment.AutomaticStoreAssignment.View'
,	[
		'btm_automaticstoreassignment_automaticstoreassignment.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_automaticstoreassignment_automaticstoreassignment_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.AutomaticStoreAssignment.AutomaticStoreAssignment.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_automaticstoreassignment_automaticstoreassignment_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/AutomaticStoreAssignment.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.AutomaticStoreAssignment.AutomaticStoreAssignment.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.AutomaticStoreAssignment.AutomaticStoreAssignment.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
